/*
 * singles-hub-cart-groups.js  (NEW FILE - theme-owned asset, S11 basket deck grouping)
 *
 * Progressive enhancement for the Woodstock cart drawer and the /cart page:
 *   - collapse/expand a deck group ([data-mcc-deck-toggle])
 *   - "Remove deck" ([data-mcc-deck-remove]) -> one POST /cart/update.js setting every line of that
 *     deck to 0, then asks the theme to re-render (Woodstock listens for its own cart events; we
 *     fall back to a page reload so the basket is never left stale)
 *   - keeps a deck's rows adjacent in the DOM (lines added at different times can be split)
 *   - on /cart (main-cart-items is NOT patched) it builds the same headers client-side from /cart.js
 *
 * Loaded once by the cart-drawer patch. Uses event delegation + a MutationObserver because the
 * drawer HTML is replaced by the Section Rendering API after every cart change.
 * No dependencies, no network calls except Shopify's own Ajax Cart API.
 */
(function () {
  'use strict';
  if (window.__mccCartGroups) return;
  window.__mccCartGroups = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var collapsed = {};
  try { collapsed = JSON.parse(sessionStorage.getItem('mcc-deck-collapsed') || '{}'); } catch (e) { collapsed = {}; }

  function saveCollapsed() {
    try { sessionStorage.setItem('mcc-deck-collapsed', JSON.stringify(collapsed)); } catch (e) { /* private mode */ }
  }

  function rowsFor(deckId, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll('tr[data-mcc-deck="' + cssEscape(deckId) + '"]'));
  }

  function cssEscape(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&');
  }

  function applyCollapsed(scope) {
    var headers = (scope || document).querySelectorAll('[data-mcc-deck-header]');
    Array.prototype.forEach.call(headers, function (h) {
      var id = h.getAttribute('data-mcc-deck-header');
      var isCollapsed = !!collapsed[id];
      var btn = h.querySelector('[data-mcc-deck-toggle]');
      if (btn) btn.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
      rowsFor(id, h.closest('table') || scope).forEach(function (r) { r.hidden = isCollapsed; });
    });
  }

  // Move every row of a deck directly under its (first) header and drop duplicate headers.
  function regroup(scope) {
    var tables = (scope || document).querySelectorAll('table');
    Array.prototype.forEach.call(tables, function (table) {
      var seen = {};
      Array.prototype.forEach.call(table.querySelectorAll('[data-mcc-deck-header]'), function (h) {
        var id = h.getAttribute('data-mcc-deck-header');
        if (seen[id]) { h.parentNode.removeChild(h); return; }
        seen[id] = true;
        var anchor = h;
        rowsFor(id, table).forEach(function (r) {
          if (anchor.nextSibling !== r) anchor.parentNode.insertBefore(r, anchor.nextSibling);
          anchor = r;
        });
      });
    });
  }

  function refresh(scope) { regroup(scope); applyCollapsed(scope); }

  function removeDeck(deckId, button) {
    if (button) { button.disabled = true; button.textContent = 'Removing…'; }
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (it) {
          if (it.properties && it.properties._deck_id === deckId) updates[it.key] = 0;
        });
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart update ' + r.status);
        delete collapsed[deckId]; saveCollapsed();
        document.dispatchEvent(new CustomEvent('mcc:cart:changed', { detail: { removedDeck: deckId } }));
        // Woodstock re-renders the drawer on its own cart events; a reload is the safe fallback.
        window.location.reload();
      })
      .catch(function () {
        if (button) { button.disabled = false; button.textContent = 'Remove deck'; }
        alert('Sorry, we could not remove that deck. Please try again.');
      });
  }

  // /cart page: main-cart-items is not patched, so build headers from /cart.js (rows are CartItem-N).
  function decorateCartPage() {
    var table = document.querySelector('#main-cart-items table, cart-items table');
    if (!table || table.querySelector('[data-mcc-deck-header]')) return;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var groups = {};
        cart.items.forEach(function (it, i) {
          var id = it.properties && it.properties._deck_id;
          if (!id) return;
          var row = document.getElementById('CartItem-' + (i + 1));
          if (!row) return;
          row.setAttribute('data-mcc-deck', id);
          var g = groups[id] || (groups[id] = { name: it.properties._deck_name || 'Deck build', cards: 0, total: 0, first: row });
          g.cards += it.quantity; g.total += it.final_line_price;
        });
        Object.keys(groups).forEach(function (id) {
          var g = groups[id];
          var tr = document.createElement('tr');
          tr.className = 'sh-cart-deck';
          tr.setAttribute('data-mcc-deck-header', id);
          var cols = g.first.children.length || 3;
          var money = (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(g.total) : '£' + (g.total / 100).toFixed(2);
          tr.innerHTML = '<td colspan="' + cols + '"><div class="sh-cart-deck__row">' +
            '<button type="button" class="sh-cart-deck__toggle" aria-expanded="true" data-mcc-deck-toggle=""></button>' +
            '<button type="button" class="sh-cart-deck__remove link" data-mcc-deck-remove="">Remove deck</button></div></td>';
          var toggle = tr.querySelector('[data-mcc-deck-toggle]');
          toggle.setAttribute('data-mcc-deck-toggle', id);
          toggle.textContent = g.name + ' · ' + g.cards + ' card' + (g.cards === 1 ? '' : 's') + ' · ' + money;
          tr.querySelector('[data-mcc-deck-remove]').setAttribute('data-mcc-deck-remove', id);
          g.first.parentNode.insertBefore(tr, g.first);
        });
        refresh(table);
      })
      .catch(function () { /* leave the page as the theme rendered it */ });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-mcc-deck-toggle],[data-mcc-deck-remove]');
    if (!t) return;
    e.preventDefault();
    var id = t.getAttribute('data-mcc-deck-toggle');
    if (id !== null) {
      collapsed[id] = !collapsed[id]; saveCollapsed(); applyCollapsed(); return;
    }
    removeDeck(t.getAttribute('data-mcc-deck-remove'), t);
  });

  function boot() {
    refresh(document);
    decorateCartPage();
    var drawer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return; pending = true;
        requestAnimationFrame(function () { pending = false; refresh(drawer); });
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
